import React, { useEffect, useState } from "react";
import { FaPlay, FaRandom, FaBuromobelexperte } from "react-icons/fa";
import { IconType } from "react-icons/lib";
import CP_Container from "../ReusableParts/CP_Stuff/CP_Container";
import SCP_Util from "../ReusableParts/CP_Stuff/SCP_Util";
import SpeedControl from "../ReusableParts/CP_Stuff/SpeedControl";
type Props = {
  setStartSolving: React.Dispatch<React.SetStateAction<Boolean>>;
  setProgressSpeed: React.Dispatch<React.SetStateAction<number>>;
  setClear: React.Dispatch<React.SetStateAction<Boolean>>;
  setBoardSize: React.Dispatch<React.SetStateAction<number>>;
};

function ChessCP({
  setStartSolving,
  setProgressSpeed,
  setClear,
  setBoardSize,
}: Props) {
  const getTitle = (title: String, curIcon: IconType) => {
    return (
      <>
        {React.createElement(curIcon, { cursor: "pointer" })}
        <span
          id="rangeValue"
          style={{
            textAlign: "center",
            fontSize: "0.9rem",
          }}
        >
          {title}
        </span>
      </>
    );
  };
  const SCP_UTIL_OPTIONS = [
    {
      toRender: <>{getTitle("Start", FaPlay)}</>,
      onClick: () => {
        setStartSolving(true);
      },
    },

    {
      toRender: getTitle("Clear", FaBuromobelexperte),
      onClick: () => {
        setClear(true);
      },
    },
  ];
  const [speed, setSpeed] = useState("50");
  const [numCells, setNumCells] = useState("60");
  useEffect(() => {
    setProgressSpeed(() => {
      return 1000 - parseInt(speed) * 99;
    });
  }, [speed]);
  useEffect(() => {
    setBoardSize(() => {
      if (parseInt(numCells) < 1) return 1;
      return Math.ceil(parseInt(numCells) * 0.16);
    });
  }, [numCells]);
  return (
    <CP_Container>
      <>
        <h2 style={{ marginBottom: "2rem", textAlign: "center" }}>N Queens</h2>
        <SpeedControl
          speed={speed}
          setSpeed={setSpeed}
          title={"Speed " + speed + "%"}
        />
        <SpeedControl
          speed={numCells}
          setSpeed={setNumCells}
          title={"Size " + numCells}
        />
        <SCP_Util options={SCP_UTIL_OPTIONS} />
      </>
    </CP_Container>
  );
}

export default ChessCP;
